<template>
  <AdaptiveSheet
    :opened="opened"
    @closed="$emit('update:opened', false)"
    class="frcp"
    :tablet-fullscreen="false"
    swipe-to-close
    backdrop
    close-by-backdrop-click
  >
    <f7-view>
      <f7-page name="feed-repost-composer">
  
            <f7-navbar>
              <f7-nav-title> {{ $t("post.repost", {}, { defaultValue: "Repartager" }) }}</f7-nav-title>
              <f7-nav-right>
                <f7-link sheet-close popup-close
                  ><f7-icon f7="multiply" size="18"
                /></f7-link>
              </f7-nav-right>
            </f7-navbar>

            <div class="frcp-compose">
              <div class="frcp-header">
                <div class="frcp-avatar" :style="avatarStyle">
                  <img
                    v-if="displayAvatar"
                    :src="displayAvatar"
                    :alt="$t('common.a11y.userAvatar')"
                    class="frcp-avatar-img"
                  />
                  <span v-else>{{ userInitials }}</span>
                </div>
                <div class="frcp-header-meta">
                  <div class="frcp-name">{{ displayName }}</div>
                  <div class="frcp-hint"> {{ $t("post.repost", {}, { defaultValue: "Repartager" }) }}</div>
                </div>
              </div>

              <textarea
                :value="text"
                @texteditor:change="(v) => (text = v)"
                :placeholder="$t('post.addComment')"
                rows="4"
                class="frcp-textarea"
                resizable
                 mode="keyboard-toolbar"
               
              />

              <FeedRepostQuote :item="item" class="frcp-quote" />

              <div class="frcp-note">
                <f7-icon f7="info_circle" :size="13" />
                <span
                  >{{ $t("post.repostHint") }} </span
                >
              </div>

              <div class="frcp-footer">
                <f7-button
                  class="frcp-submit"
                  fill
                  raised
                  :disabled="submitting"
                  @click="submit"
                >
                  {{ $t("post.repost", {}, { defaultValue: "Repartager" }) }}
                </f7-button>
              </div>
            </div>
      
      </f7-page>
    </f7-view>
  </AdaptiveSheet>
</template>

<script setup>
import { ref, computed } from "vue";
import { useAccountStore } from "../../js/pinia-stores/account.js";
import FeedRepostQuote from "./FeedRepostQuote.vue";
import AdaptiveSheet from "../common/AdaptiveSheet.vue";
const props = defineProps({
  opened: { type: Boolean, default: false },
  item: { type: Object, required: true },
  userName: { type: String, default: "" },
  userAvatar: { type: String, default: "" },
});

const emit = defineEmits(["update:opened", "submit"]);

const accountStore = useAccountStore();

const text = ref("");
const submitting = ref(false);

const displayName = computed(
  () => props.userName || accountStore.userAccount?.name || "",
);
const displayAvatar = computed(
  () => props.userAvatar || accountStore.userAccount?.avatar || "",
);

const userInitials = computed(() => {
  const name = displayName.value;
  return (
    name
      .split(" ")
      .map((w) => w[0])
      .join("")
      .substring(0, 2)
      .toUpperCase() || "?"
  );
});

const avatarStyle = computed(() => {
  return { background: "#1A6B42", color: "#fff" };
});

function submit() {
  if (submitting.value) return;
  submitting.value = true;
  emit("submit", { postId: props.item.id, text: text.value.trim() });
  text.value = "";
  submitting.value = false;
  emit("update:opened", false);
}
</script>

<style scoped>
.frcp-compose {
  padding: 16px;
}
.frcp-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}
.frcp-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  flex-shrink: 0;
  overflow: hidden;
}
.frcp-avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.frcp-header-meta {
  min-width: 0;
}
.frcp-name {
  font-size: 13px;
  font-weight: 500;
}
.frcp-hint {
  font-size: 10px;
  color: var(--f7-on-surface-variant, #8e8e93);
}
.frcp-textarea {
  width: 100%;
  border: none;
  padding: 8px 0;
  font-size: 13px;
  line-height: 1.5;
  outline: none;
  resize: none;
  background: transparent;
  margin-bottom: 10px;
}
.frcp-quote {
  margin-bottom: 10px;
}
.frcp-note {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 10px;
  color: var(--f7-on-surface-variant, #8e8e93);
  margin-bottom: 14px;
}
.frcp-footer {
  margin-top: 4px;
}
.frcp-submit {
  --f7-button-bg-color: var(--avocash-green, #1a6b42);
  --f7-button-text-color: #fff;
  --f7-button-border-radius: 10px;
  --f7-button-font-size: 13px;
  --f7-button-font-weight: 500;
}
</style>
